import React from "react";
import PropTypes from "prop-types";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
// MDB Shim Imports
import Card from "../../Component/MDBShim/Card";
import CardBody from "../../Component/MDBShim/CardBody";
import CardHeader from "../../Component/MDBShim/CardHeader";
import Container from "../../Component/MDBShim/Container";
import Input from "../../Component/MDBShim/Input";
import toast from "../../Component/MDBShim/toast";
import ToastContainer from "../../Component/MDBShim/ToastContainer";
import Col from "../../Component/MDBShim/Col";
import Row from "../../Component/MDBShim/Row";
import MDBInput from "../../Component/MDBShim/MDBInput";
import MDBBtn from "../../Component/MDBShim/MDBBtn";

import UserService from "../Security/UserService/userService";
import api from "../Security/api";
import "./userEdit.css";
import Select from "react-select";
import LayerLegacy from "../../LayerLegacy";
import MainContext from "../../Context/MainContext/MainContext";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUIChip from "@mui/material/Chip";
import MUITextField from "@mui/material/TextField";
import MUIThemeProvider from "@mui/material/styles/ThemeProvider";
import MUICreateTheme from "@mui/material/styles/createTheme";
import Role from "../../Utility/Crud/Role";
import ROLE_SETTINGS_BY_NEW_ROLE_ID from "./RoleSettingsByNewRoleId";
import Format from "../../Utility/Format";
import Validator from "../../Utility/Validator";

const fixedLightMaterialUITheme = MUICreateTheme({ palette: { mode: "light" } });

export default class userAdd extends LayerLegacy {
    constructor(props) {
        super(props);

        this.state = {
            nUser: {
                username: "",
                email: "",
                firstname: "",
                lastname: "",
                phone: "",
                fax: "",
                role: "",
                userprofileLocations: [],
                active: true,
                canEditPoints: false,
                isAtp: false,
            },
            locations: [
                {
                    label: "Loading...",
                    value: "loading",
                },
            ],
            locationsSelected: [],
            selectedRoleIds: [],
        };
    }

    componentDidMount() {
        this.getLocations();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { allLocations } = this.context;
        let st = this.state;
        if (st.locations.length !== allLocations.length) {
            this.getLocations();
        }
    }

    static contextType = MainContext; // For legacy class components

    deriveUsername(email) {
        if (!email || !email.includes("@")) {
            return "";
        }
        return email.split("@")[0].trim();
    }

    requiresRehabMedicalEmail(email) {
        const { companyName } = this.context;
        return ["rehabmedical", "uat"].includes(String(companyName).toLowerCase())
            && Boolean(email)
            && !email.trim().toLowerCase().endsWith("@rehabmedical.com");
    }

    getRoleOptions() {
        const { rolesIndexed } = this.context;
        const roles = rolesIndexed ? Object.values(rolesIndexed) : [];
        return Role.sort(roles);
    }

    getLegacyRoleOptions() {
        return Array.from(new Set(Object.values(ROLE_SETTINGS_BY_NEW_ROLE_ID).map((settings) => settings.legacyRole))).sort();
    }

    getRoleSettingsFromMostRecentRole(previousRoleIds, nextRoles) {
        const previousRoleIdsSet = new Set((previousRoleIds || []).map((roleId) => String(roleId)));
        const addedRoles = (nextRoles || []).filter((role) => !previousRoleIdsSet.has(String(role.id)));
        if (addedRoles.length === 0) {
            return null;
        }
        const mostRecentAddedRole = addedRoles[addedRoles.length - 1];
        return ROLE_SETTINGS_BY_NEW_ROLE_ID[mostRecentAddedRole.id] || null;
    }

    addCorporateLocation(user, locationsSelected = null) {
        const currentUserProfileLocations = user.userprofileLocations || [];
        const hasCorporateUserProfileLocation = currentUserProfileLocations.some((location) => Number(location.locationsId) === 1);
        const nextLocationsSelected = locationsSelected ? [...locationsSelected] : null;
        let nextUser = user;

        if (!hasCorporateUserProfileLocation) {
            nextUser = {
                ...user,
                userprofileLocations: currentUserProfileLocations.concat([{ locationsId: 1 }]),
            };
        }

        if (nextLocationsSelected) {
            const hasCorporateSelected = nextLocationsSelected.some((location) => Number(location?.val?.id) === 1);
            if (!hasCorporateSelected) {
                const corporateLocation = (this.state.locations || []).find((location) => Number(location?.val?.id) === 1);
                if (corporateLocation) {
                    nextLocationsSelected.push(corporateLocation);
                }
            }
        }

        return { nextUser, nextLocationsSelected };
    }

    handleRolesChange = (e, roles, reason) => {
        const nextSelectedRoleIds = reason === "selectOption"
            ? (roles.length > 0 ? [roles[roles.length - 1].id] : [])
            : roles.map((role) => role.id);
        const mappedSettings = this.getRoleSettingsFromMostRecentRole(this.state.selectedRoleIds, roles);

        this.setState((prevState) => ({
            selectedRoleIds: nextSelectedRoleIds,
            ...(() => {
                if (!mappedSettings) {
                    return { nUser: prevState.nUser };
                }

                const updatedUser = {
                    ...prevState.nUser,
                    role: mappedSettings.legacyRole,
                    canEditPoints: mappedSettings.canEditPoints,
                    isAtp: mappedSettings.isAtp,
                };

                if (!mappedSettings.corporate) {
                    return { nUser: updatedUser };
                }

                const { nextUser, nextLocationsSelected } = this.addCorporateLocation(updatedUser, prevState.locationsSelected);
                return {
                    nUser: nextUser,
                    locationsSelected: nextLocationsSelected || prevState.locationsSelected,
                };
            })(),
        }));
    };

    handleLegacyRoleChange = (e, legacyRole) => {
        this.setState((prevState) => ({
            nUser: {
                ...prevState.nUser,
                role: legacyRole || "",
            },
        }));
    };

    saveUserprofileRoleChanges(userId) {
        const selectedRoleIds = [...new Set(this.state.selectedRoleIds || [])];
        const addPromises = selectedRoleIds.map((roleId) =>
            api.send("POST", "/userprofileRole", {
                userProfileId: userId,
                roleId: roleId,
            }).then((createdUserprofileRole) => {
                this.context.updateIndexed("userprofileRolesIndexed", createdUserprofileRole);
                return createdUserprofileRole;
            })
        );

        return Promise.all(addPromises);
    }

    getLocations() {
        const { allLocations } = this.context;
        let l = [];
        allLocations.map((loc) => {
            return l.push({
                label: loc.name,
                value: loc.name,
                val: {
                    id: loc.id,
                    name: loc.name,
                },
            });
        });
        this.setState({
            locations: l,
        });
    }

    handleChange = (property, event) => {
        //update the property that the user has edited in the order...BC
        const nUser = this.state.nUser;
        if (property === "email") {
            nUser.email = event.target.value;
            nUser.username = this.deriveUsername(event.target.value);
            this.setState({ nUser: nUser });
            return;
        } else {
            nUser[property] = event.target.value;
        }
        this.setState({ nUser: nUser });
    };

    handlePhoneOrFaxNumberChange = (property, event) => {
        const { value } = event.target;
        const digits = value.replace(/\D/g, '').slice(0, 10);
        this.setState({ nUser: { ...this.state.nUser, [property]: digits ? digits : null } });
    };

    handleBlur = (property, event) => {
        const nUser = this.state.nUser;
        const value = event?.target?.value;
        if (typeof value !== "string") {
            return;
        }

        nUser[property] = value.trim();
        if (property === "email") {
            nUser.username = this.deriveUsername(nUser[property]);
        }

        this.setState({ nUser: nUser });
    };

    validateForm() {
        let n = this.state.nUser;

        if (n.username === "") {
            return "Please enter a username.";
        }
        if (n.firstname === "") {
            return "Please enter a first name.";
        }
        if (n.lastname === "") {
            return "Please enter a last name.";
        }
        if (n.phone && !Validator.validatePhone(n.phone)) {
            return "Please enter a valid 10-digit phone number.";
        }
        if (n.fax && !Validator.validatePhone(n.fax)) {
            return "Please enter a valid 10-digit fax number.";
        }
        if (n.email === "") {
            return "Please enter an email address.";
        }
        if (!(n.email.includes("@") && n.email.includes("."))) {
            return "Please enter a valid email address.";
        }
        if (this.requiresRehabMedicalEmail(n.email)) {
            return "Only emails ending in @rehabmedical are allowed.";
        }
        if ((this.state.selectedRoleIds || []).length === 0) {
            return "Please select at least one new role.";
        }
        if (n.role === "") {
            return "Please choose a legacy role.";
        }
        if (!n.userprofileLocations || n.userprofileLocations.length === 0) {
            return "Please add at least 1 location.";
        }
        return true;
    }

    addUser() {
        let st = this.state,
            user = st.nUser;
        user.email = user.email.trim();
        user.username = this.deriveUsername(user.email);
        return UserService.createUser(user)
            .then((res) => this.saveUserprofileRoleChanges(res.id).then(() => res))
            .then((res) => {
                toast.success("Saved Successfully!");
                NotistackEnqueueSnackbar('Saved Successfully!', { variant: "success" });
                let nUser = {
                    username: "",
                    password: "",
                    retypePassword: "",
                    firstname: "",
                    lastname: "",
                    email: "",
                    phone: "",
                    fax: "",
                    role: "",
                    userprofileLocations: [],
                    active: true,
                    canEditPoints: false,
                    isAtp: false,
                };
                this.setState({
                    nUser: nUser,
                    locationsSelected: [],
                    selectedRoleIds: [],
                });
                //if (st.locationsSelected.length > 0) {
                //	st.locationsSelected.map((loc) => {
                //		return l.push(loc.val);
                //	});
                //	res.userProfileLocations = l.map(x => {
                //		return { locationsId: x.id }
                //	}) || [];
                //	return UserService.updateUser(res)
                //		.then((data) => {
                //			this.setState({
                //				locationsSelected: [],
                //			});
                //			toast.success("Locations Set Successfully!");
                //		})
                //		.catch((err) => {
                //			toast.warn("An error occurred while saving.");
                //		});
                //}
                //else{
                //	toast.warn("An error occurred creating the user.")
                //}
            })
            .catch((err) => {
                console.log(err);
                toast.warn("Oh! There was an error creating the user.");
                NotistackEnqueueSnackbar('Oh! There was an error creating the user.', { variant: "error" });
            });
    }

    renderLocationsCard() {
        let st = this.state;
        return (
            <MUIThemeProvider theme={fixedLightMaterialUITheme}>
            <div style={{ color: "rgba(0, 0, 0, 0.87)" }}>
            <Card>
                <CardHeader
                    style={{ textAlign: "center", backgroundColor: "#5881C1", color: "#FFF", fontSize: 30, minHeight: 82, margin: "0"}}
                    className="form-header text-center">
                    <h2>Locations</h2>
                </CardHeader>
                <CardBody>
                    <Select
                        placeholder={"Select Location..."}
                        options={st.locations}
                        isMulti
                        onChange={this.handleLocationChange.bind(this)}
                        value={st.locationsSelected}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                </CardBody>
            </Card>
            </div>
            </MUIThemeProvider>
        );
    }

    handleLocationChange = (e) => {
        console.log(e);
        let u = this.state.nUser;
        u.userprofileLocations = [];
        if (e && e.length > 0) {
            e.map(x => u.userprofileLocations.push({ locationsId: x.val.id }));
        }
        this.setState({
            locationsSelected: e,
            nUser: u,
        });
    };

    handlePoints = () => {
        let u = this.state.nUser;
        u.canEditPoints = !u.canEditPoints;
        this.setState({
            nUser: u,
        });
    };

    handleAtp = () => {
        let u = this.state.nUser;
        u.isAtp = !u.isAtp;
        this.setState({
            nUser: u,
        });
    };

    renderErrorMessage() {
        let res = this.validateForm(),
            color = "green darken-2",
            text = "Create User",
            disable = false,
            onClick = this.addUser.bind(this);

        //if the form is not valid, change the style...BC
        if (res !== true) {
            disable = true;
            text = res;
            color = "pink darken-4";
            onClick = () => {
                return;
            };
        }

        //return the chip...BC
        return (
            <MDBBtn
                // outline={this.state.rotateMode}
                disabled={disable}
                rounded
                color={color}
                data-tip={text}
                onClick={onClick}
                style={{fontSize: "15px", padding: "5px 15px 5px 15px"}}
            >
                {text}
                {/*<MDBIcon far icon="check-circle"*/}
                {/*		 style={{fontSize: "14px", paddingLeft: "3px", color: "black"}}/>*/}
            </MDBBtn>
        // <Chip
        // 	className="userHeader"
        // 	size="lg"
        // 	bgColor={color}
        // 	text="white"
        // 	onClick={onClick}
        // >
        // 	{text}
        // </Chip>
        );
    }

    renderContent() {
        let user = this.state.nUser;
        const roleOptions = this.getRoleOptions();
        const selectedRoleIdsSet = new Set((this.state.selectedRoleIds || []).map((roleId) => String(roleId)));
        const selectedRoles = roleOptions.filter((role) => selectedRoleIdsSet.has(String(role.id)));
        return (
            <div>
                <ToastContainer
                    hideProgressBar={false}
                    newestOnTop={true}
                    autoClose={3000}
                />
                <Container style={{ marginTop: 30, maxWidth: "1200px", width: "100%" }}>
                    <Row style={{ gap: "16px" }}>
                        <Col size="7">
                            <MUIThemeProvider theme={fixedLightMaterialUITheme}>
                            <div style={{ color: "rgba(0, 0, 0, 0.87)" }}>
                            <Card>
                                <CardHeader
                                    style={{ textAlign: "center", backgroundColor: "#5881C1", color: "#FFF", fontSize: 30, minHeight: 82, margin: "0" }}
                                    className="form-header text-center"
                                >
                                    <h2 style={{marginBottom: "0"}}>
										Create New User
                                    </h2>
                                </CardHeader>
                                <CardBody>
                                    <Row style={{ marginBottom: "15px" }}>
                                        <Col size="12">
                                            <Input
                                                fullWidth={true}
                                                outline
                                                value={user.email || ""}
                                                onChange={this.handleChange.bind(this, "email")}
                                                onBlur={this.handleBlur.bind(this, "email")}
                                                label="Email"
                                                size="small"
                                            />
                                            {this.requiresRehabMedicalEmail(user.email) && (
                                                <div style={{ color: "#c62828", fontSize: "0.875rem", marginTop: "4px" }}>
                                                    email must be @rehabmedical
                                                </div>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row gap={1} style={{ marginBottom: "15px" }}>
                                        <Col size="5.9">
                                            <Input
                                                fullWidth={true}
                                                outline
                                                value={user.firstname || ""}
                                                onChange={this.handleChange.bind(this, "firstname")}
                                                onBlur={this.handleBlur.bind(this, "firstname")}
                                                label="First Name"
                                                size="small"
                                            />
                                        </Col>

                                        <Col size="5.9">
                                            <Input
                                                fullWidth={true}
                                                outline
                                                value={user.lastname || ""}
                                                onChange={this.handleChange.bind(this, "lastname")}
                                                onBlur={this.handleBlur.bind(this, "lastname")}
                                                label="Last Name"
                                                size="small"
                                            />
                                        </Col>
                                    </Row>

                                    <Row gap={1} style={{ marginBottom: "15px" }}>
                                        <Col size="5.9">
                                            <Input
                                                fullWidth={true}
                                                outline
                                                value={Format.phone(user.fax)}
                                                onChange={this.handlePhoneOrFaxNumberChange.bind(this, "fax")}
                                                size="small"
                                                label="Fax"
                                            />
                                        </Col>

                                        <Col size="5.9">
                                            <Input
                                                fullWidth={true}
                                                outline
                                                value={Format.phone(user.phone)}
                                                onChange={this.handlePhoneOrFaxNumberChange.bind(this, "phone")}
                                                size="small"
                                                label="Phone"
                                            />
                                        </Col>
                                    </Row>

                                    <Row style={{ marginBottom: "15px" }}>
                                        <Col size="12">
                                            <Input
                                                fullWidth={true}
                                                outline
                                                value={user.username || ""}
                                                label="Username"
                                                size="small"
                                                disabled
                                                style={{ opacity: 0.55, cursor: "not-allowed" }}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col size="12">
                                            <div style={{ marginTop: 16 }}>
                                                <hr style={{ marginBottom: 16 }} />
                                                <h5 style={{ marginBottom: 16 }}>Roles & Permissions</h5>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col size="12">
                                            <MUIAutocomplete
                                                multiple
                                                options={roleOptions}
                                                value={selectedRoles}
                                                getOptionLabel={(role) => Role.getDisplayName(role)}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                onChange={this.handleRolesChange}
                                                renderTags={(value, getTagProps) =>
                                                    value.map((option, index) => (
                                                        <MUIChip
                                                            size="small"
                                                            label={Role.getDisplayName(option)}
                                                            {...getTagProps({ index })}
                                                            key={option.id}
                                                        />
                                                    ))
                                                }
                                                renderInput={(params) => (
                                                    <MUITextField
                                                        {...params}
                                                        InputLabelProps={{ shrink: true }}
                                                        size="small"
                                                        label="Roles"
                                                        variant="standard"
                                                    />
                                                )}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col size="12">
                                            <div style={{ marginTop: 12 }}>
                                                <MUIAutocomplete
                                                    options={this.getLegacyRoleOptions()}
                                                    value={user.role || ""}
                                                    onChange={this.handleLegacyRoleChange}
                                                    renderInput={(params) => (
                                                        <MUITextField
                                                            {...params}
                                                            InputLabelProps={{ shrink: true }}
                                                            size="small"
                                                            label="Legacy Role"
                                                            variant="standard"
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col size="4">
                                            <MDBInput
                                                id="pointsStatus"
                                                label="Can Edit Points"
                                                checked={user.canEditPoints}
                                                value={user.canEditPoints}
                                                onChange={this.handlePoints}
                                                type="checkbox"
                                            />
                                        </Col>

                                        <Col size="4">
                                            <MDBInput
                                                id="atpStatus"
                                                label="is ATP"
                                                checked={user.isAtp}
                                                value={user.isAtp}
                                                onChange={this.handleAtp}
                                                type="checkbox"
                                            />
                                        </Col>

                                    </Row>
                                    <Row style={{display: "flex", justifyContent: "center"}}>
                                        {this.renderErrorMessage()}
                                    </Row>
                                </CardBody>
                            </Card>
                            </div>
                            </MUIThemeProvider>
                        </Col>
                        <Col size="4.8">{this.renderLocationsCard()}</Col>
                    </Row>
                </Container>
            </div>
        );
    }
}


